"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiAppResponseToJSON = exports.ApiAppResponseFromJSONTyped = exports.ApiAppResponseFromJSON = exports.instanceOfApiAppResponse = exports.attributeTypeMapApiAppResponse = void 0;
var ApiAppResponseOAuth_1 = require("./ApiAppResponseOAuth");
var ApiAppResponseWhiteLabelingOptions_1 = require("./ApiAppResponseWhiteLabelingOptions");
var ApiAppResponseOptions_1 = require("./ApiAppResponseOptions");
var ApiAppResponseOwnerAccount_1 = require("./ApiAppResponseOwnerAccount");
exports.attributeTypeMapApiAppResponse = [
    {
        name: "clientId",
        type: "string",
    },
    {
        name: "createdAt",
        type: "number",
    },
    {
        name: "domains",
        type: "Array<string>",
    },
    {
        name: "name",
        type: "string",
    },
    {
        name: "isApproved",
        type: "boolean",
    },
    {
        name: "isEligibleForSelfApprove",
        type: "boolean",
    },
    {
        name: "ownerAccount",
        type: "ApiAppResponseOwnerAccount",
    },
    {
        name: "callbackUrl",
        type: "string",
    },
    {
        name: "oauth",
        type: "ApiAppResponseOAuth",
    },
    {
        name: "options",
        type: "ApiAppResponseOptions",
    },
    {
        name: "whiteLabelingOptions",
        type: "ApiAppResponseWhiteLabelingOptions",
    },
];
/**
 * Check if a given object implements the ApiAppResponse interface.
 */
function instanceOfApiAppResponse(value) {
    if (!("clientId" in value) || value["clientId"] === undefined)
        return false;
    if (!("createdAt" in value) || value["createdAt"] === undefined)
        return false;
    if (!("domains" in value) || value["domains"] === undefined)
        return false;
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("isApproved" in value) || value["isApproved"] === undefined)
        return false;
    if (!("isEligibleForSelfApprove" in value) ||
        value["isEligibleForSelfApprove"] === undefined)
        return false;
    if (!("ownerAccount" in value) || value["ownerAccount"] === undefined)
        return false;
    return true;
}
exports.instanceOfApiAppResponse = instanceOfApiAppResponse;
function ApiAppResponseFromJSON(json) {
    return ApiAppResponseFromJSONTyped(json, false);
}
exports.ApiAppResponseFromJSON = ApiAppResponseFromJSON;
function ApiAppResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        clientId: json["client_id"],
        createdAt: json["created_at"],
        domains: json["domains"],
        name: json["name"],
        isApproved: json["is_approved"],
        isEligibleForSelfApprove: json["is_eligible_for_self_approve"],
        ownerAccount: (0, ApiAppResponseOwnerAccount_1.ApiAppResponseOwnerAccountFromJSON)(json["owner_account"]),
        callbackUrl: json["callback_url"] == null ? undefined : json["callback_url"],
        oauth: json["oauth"] == null
            ? undefined
            : (0, ApiAppResponseOAuth_1.ApiAppResponseOAuthFromJSON)(json["oauth"]),
        options: json["options"] == null
            ? undefined
            : (0, ApiAppResponseOptions_1.ApiAppResponseOptionsFromJSON)(json["options"]),
        whiteLabelingOptions: json["white_labeling_options"] == null
            ? undefined
            : (0, ApiAppResponseWhiteLabelingOptions_1.ApiAppResponseWhiteLabelingOptionsFromJSON)(json["white_labeling_options"]),
    };
}
exports.ApiAppResponseFromJSONTyped = ApiAppResponseFromJSONTyped;
function ApiAppResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        client_id: value["clientId"],
        created_at: value["createdAt"],
        domains: value["domains"],
        name: value["name"],
        is_approved: value["isApproved"],
        is_eligible_for_self_approve: value["isEligibleForSelfApprove"],
        owner_account: (0, ApiAppResponseOwnerAccount_1.ApiAppResponseOwnerAccountToJSON)(value["ownerAccount"]),
        callback_url: value["callbackUrl"],
        oauth: (0, ApiAppResponseOAuth_1.ApiAppResponseOAuthToJSON)(value["oauth"]),
        options: (0, ApiAppResponseOptions_1.ApiAppResponseOptionsToJSON)(value["options"]),
        white_labeling_options: (0, ApiAppResponseWhiteLabelingOptions_1.ApiAppResponseWhiteLabelingOptionsToJSON)(value["whiteLabelingOptions"]),
    };
}
exports.ApiAppResponseToJSON = ApiAppResponseToJSON;
